import React from 'react'
import {motion} from "framer-motion";
import {CooksInfoData} from '../../utils/static'


const CooksInfo = () => {
    const [imageLoaded, setImageLoaded] = React.useState(false);

    return (
        <section className='grid grid-cols-1 md:grid-cols-2 gap-2 w-full px-3 py-3 md:px-8 ' id='cooks'>
            {CooksInfoData.map((item, index) => (
                <div key={index}>
                    <div className="py-2 flex-1 flex flex-col items-start justify-center gap-3">
                        <p className="text-[1rem] lg:text-[4rem] font-bold tracking-wide text-headingColor">
                            {item.title}
                        </p>
                        <p className="text-base text-textColor text-center md:text-left md:w-[80%]">
                            {item.text}
                        </p>
                    </div>
                    <div className="py-2 flex items-center relative">
                        <div
                            className="cursor-pointer min-h-[140px] lg:min-h-[210px] min-w-[150px] lg:min-w-[200px] drop-shadow-lg p-2 bg-cardOverlay backdrop-blur-md rounded-xl flex flex-col items-center justify-center"
                        >
                            <motion.img
                                whileHover={{scale: 1.1}}
                                whileTap={{scale: 1.1}}
                                src={item.imgSrc}
                                alt="icecream"
                                style={{
                                    opacity: imageLoaded ? "1" : "0",
                                    transition: "opacity 2s ease-in",
                                }}
                                className="ml-auto lg:h-[550px] h-[420px] w-full lg:w-auto rounded-lg"
                                onLoad={() => setImageLoaded(true)}
                                loading="eager"
                            />
                        </div>
                    </div>
                </div>
            ))}
        </section>
    )
}

export default CooksInfo